var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",on:{"click":_vm.onGoPro}},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.img,"fit":"contain"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }